import React, { useMemo } from 'react';
import { Space, Tag, Typography } from 'antd';
import * as Icons from '@ant-design/icons';

type LocationCategory = {
  id: string;
  categoryLabel: string;
  color?: string | null;
  icon?: string | null;
  isActive: boolean;
};

type AntIconComponent = React.ComponentType<React.ComponentProps<typeof Icons.HomeOutlined>>;

export function LocationCategoryLegend({
  categories,
  usedCategoryIds,
}: {
  categories: LocationCategory[];
  usedCategoryIds: Set<string>;
}) {
  const usedCategories = useMemo(
    () => categories.filter((c) => usedCategoryIds.has(c.id)),
    [categories, usedCategoryIds]
  );

  const getIconNode = (iconName?: string | null): React.ReactNode => {
    if (!iconName || !(iconName in Icons)) {
      return null;
    }
    const iconMap = Icons as unknown as Record<string, AntIconComponent>;
    const IconComponent = iconMap[iconName];
    if (!IconComponent) {
      return null;
    }
    return <IconComponent />;
  };

  if (usedCategories.length === 0) {
    return null;
  }

  return (
    <div style={{ marginTop: 8 }}>
      <Typography.Text type="secondary" style={{ display: 'block', marginBottom: 4 }}>
        カテゴリ凡例
      </Typography.Text>
      <Space size={[8, 8]} wrap>
        {usedCategories.map((c) => (
          <Tag
            key={c.id}
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: 6,
              opacity: c.isActive ? 1 : 0.6,
            }}
          >
            {c.icon ? getIconNode(c.icon) : null}
            <span
              style={{
                width: 10,
                height: 10,
                borderRadius: 2,
                backgroundColor: c.color ?? '#ffffff',
                display: 'inline-block',
                border: '1px solid rgba(0,0,0,0.15)',
              }}
            />
            {c.categoryLabel}
          </Tag>
        ))}
      </Space>
    </div>
  );
}
